export const SchoolType = [
  {
    label: "Any",
    value: "",
  },
  {
    label: "Public",
    value: "1",
  },
  {
    label: "Private",
    value: "2",
  },
];

export const ScholarshipType = [
  {
    label: "Any",
    value: "",
  },
  {
    label: "Yes",
    value: "yes",
  },
  {
    label: "No",
    value: "no",
  },
];
